/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequency per 1000 lets you compare codon use between sequences of different length.`)
};

const es_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La frecuencia por 1000 permite comparar el uso de codones entre secuencias de diferente longitud.`)
};

const de_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Häufigkeit pro 1000 ermöglicht den Vergleich der Codon-Nutzung zwischen Sequenzen unterschiedlicher Länge.`)
};

const nl_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequentie per 1000 laat je codongebruik vergelijken tussen sequenties van verschillende lengte.`)
};

const fr_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fréquence pour 1000 permet de comparer l'usage des codons entre séquences de longueurs différentes.`)
};

const it_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La frequenza per 1000 permette di confrontare l'uso dei codoni tra sequenze di lunghezza diversa.`)
};

const pt_br2_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A frequência por 1000 permite comparar o uso de códons entre sequências de comprimentos diferentes.`)
};

const pt_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A frequência por 1000 permite comparar o uso de codões entre sequências de comprimento diferente.`)
};

const ja_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1000あたりの頻度を使うと、異なる長さの配列間でコドン使用を比較できます。`)
};

const zh_codon_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每千个密码子的频率可用于比较不同长度序列之间的密码子使用情况。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_ex2", locale)
	if (locale === "en") return en_codon_ex2(inputs)
	if (locale === "es") return es_codon_ex2(inputs)
	if (locale === "de") return de_codon_ex2(inputs)
	if (locale === "nl") return nl_codon_ex2(inputs)
	if (locale === "fr") return fr_codon_ex2(inputs)
	if (locale === "it") return it_codon_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_codon_ex2(inputs)
	if (locale === "pt") return pt_codon_ex2(inputs)
	if (locale === "ja") return ja_codon_ex2(inputs)
	return zh_codon_ex2(inputs)
};